module.exports = __webpack_public_path__ + "static/cross.08449f4d.svg";